<div id="location-roles" data-automation="location-roles">
    <div class="location-selection">
        <!-- tabs here-->
        <mat-tab-group animationDuration="10ms" (selectedIndexChange)="onChangeSelectedTab($event)">
            <!--organization hirarchy tab-->
            <mat-tab>
                <ng-template mat-tab-label>
                    <span (click)="deselectAllLocations()" (keypress)="deselectAllLocations()">{{
                        'user.edit.locations.organizations' | translate
                    }}</span>
                </ng-template>
            </mat-tab>

            <!--market hirarchy tab-->
            <mat-tab>
                <ng-template mat-tab-label>
                    <span (click)="deselectAllLocations()" (keypress)="deselectAllLocations()">{{
                        'user.edit.locations.market' | translate
                    }}</span>
                </ng-template>
            </mat-tab>

            <!--Admin groups tab-->
            <mat-tab>
                <ng-template mat-tab-label>
                    <span (click)="deselectAllLocations()" (keypress)="deselectAllLocations()">{{
                        'user.edit.locations.admin_groups' | translate
                    }}</span>
                </ng-template>
            </mat-tab>

            <!--Dr groups tab-->
            <mat-tab>
                <ng-template mat-tab-label>
                    <span (click)="deselectAllLocations()" (keypress)="deselectAllLocations()">{{
                        'user.edit.locations.dr_groups' | translate
                    }}</span>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <!-- search -->
        <div [ngClass]="loadingHierarchy ? 'search-disabled dr-search' : 'search-enabled dr-search'">
            <mat-icon class="search-icon">search</mat-icon>
            <input
                matInput
                class="context-search-input"
                data-automation-name="search-text-field"
                [(ngModel)]="searchText"
                (ngModelChange)="searchTextChange()"
                [disabled]="loadingHierarchy"
                placeholder="{{ 'user.placeholder.search' | translate }}"
                autofocus
            />
        </div>

        <div *ngIf="currentTab == 0" class="radio-btn-container">
            <mat-radio-group
                [value]="showOnlyPrimaryOrg"
                (change)="switchHierarchy($event)"
                aria-label="Select an option"
                [disabled]="loadingHierarchy"
            >
                <mat-radio-button [value]="true">{{ 'user.edit.show_only_primary' | translate }}</mat-radio-button>
                <mat-radio-button [value]="false">{{ 'user.edit.show_all_orgs' | translate }}</mat-radio-button>
            </mat-radio-group>
        </div>

        <div *ngIf="!loadingHierarchy" class="row">
            <div class="col tree-container" data-automation="tree-container">
                <ng-container>
                    <enel-tree-display
                        #locationTree
                        [treeData]="treeData$ | async"
                        [multiSelect]="multiSelect"
                        [checkbox]="true"
                        [expandable]="true"
                        [showSearch]="false"
                        [showControls]="true"
                        [iconDefinitions]="iconMap"
                        [iconIdentifier]="iconIdentifier"
                        [searchString]="searchText"
                        [checkbox]="true"
                        [maxSelections]="maxSelections"
                        [selectedNodes]="selectedSpaces"
                        [expandedNodes]="expandedKeys"
                        [allowSelectAllResults]="false"
                        (expansion$)="handleExpand($event)"
                        (selection$)="handleSelection($event)"
                        (deselection$)="handleDeselection($event)"
                    >
                    </enel-tree-display>
                </ng-container>
            </div>
        </div>

        <div *ngIf="loadingHierarchy" class="spaces-loading-spinner">
            <mat-spinner color="primary" diameter="40"></mat-spinner>
        </div>
        <!--buttons-->
        <div class="btn-container">
            <button
                mat-button
                color="primary"
                [disabled]="loadingHierarchy"
                (click)="selectAllLocations()"
                data-automation="selectAllLocations"
            >
                {{ 'user.edit.select_all' | translate }}
            </button>
            <button
                mat-button
                color="primary"
                [disabled]="loadingHierarchy"
                (click)="deselectAllLocations()"
                data-automation="deselectAllLocations"
            >
                {{ 'user.edit.clear_selection' | translate }}
            </button>
        </div>
    </div>
    <div class="roles-selection">
        <div class="roles-list">
            <h6 class="roles-title" data-automation="selectRoleHeader">{{ 'user.edit.select_roles' | translate }}</h6>
            <mat-form-field class="example-chip-list" floatLabel="always">
                <mat-label>{{ 'user.edit.placeholder.click_or_type' | translate }}</mat-label>
                <input
                    matInput
                    placeholder="{{ 'user.edit.placeholder.click_or_type' | translate }}"
                    #roleInput
                    class="ellipsis role-search-input"
                    [formControl]="roleCtrl"
                    data-automation="role_search_input"
                    [attr.disabled]="disableRoleSelection ? '' : null"
                    (click)="!disableRoleSelection && roleSelect.open()"
                />
                <mat-icon
                    data-automation="role_search_input_icon"
                    matSuffix
                    (click)="!disableRoleSelection && roleSelect.open()"
                    [class.disabled-icon]="disableRoleSelection"
                    >arrow_drop_down</mat-icon
                >
                <mat-select #roleSelect [formControl]="chipsFormControl" multiple class="role-select">
                    <mat-option
                        *ngFor="let role of filteredRoles$ | async"
                        [value]="role"
                        data-automation="role_search_option"
                        [disabled]="checkRoleDisabled(role.name)"
                        [matTooltip]="
                            checkRoleDisabled(role.name) ? ('user.edit.roles_notifications_disabled' | translate) : ''
                        "
                    >
                        {{ role.displayLabel }}
                    </mat-option>
                    <mat-option
                        *ngFor="let role of selectedRoles"
                        class="selected-role-option"
                        [value]="role"
                    ></mat-option>
                </mat-select>
            </mat-form-field>
            <div class="selected-roles-container">
                <mat-chip-list>
                    <mat-chip
                        *ngFor="let role of selectedRoles"
                        (removed)="removeRole(role.name)"
                        [selectable]="true"
                        [selected]="true"
                        [removable]="!disableRoleSelection"
                        color="primary"
                        data-automation="selected_role_chip"
                    >
                        {{ role.displayLabel }}
                        <mat-icon matChipRemove *ngIf="!disableRoleSelection">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>

            <br class="clearfix" />

            <button
                class="icon-btn x-btn-primary apply-roles"
                (click)="applyRoles()"
                data-automation="applyRolesBtn"
                [disabled]="!selectedRoles.length || !selectedKeys.size"
            >
                <mat-icon *ngIf="!applyingRoles">done</mat-icon>
                <div *ngIf="applyingRoles" class="btn-spinner">
                    <mat-spinner diameter="15"></mat-spinner>
                </div>
                <span class="btn-text">{{ 'user.edit.button.add_roles' | translate }}</span>
            </button>
            <mat-error *ngIf="illegalSubs.length > 0">
                {{ 'user.edit.active_roles.failed' | translate }} {{ illegalSubs.join(', ') }}
            </mat-error>
        </div>

        <div *ngIf="loadingRoles" class="spaces-loading-spinner">
            <mat-spinner color="primary" diameter="40"></mat-spinner>
        </div>
    </div>
    <div class="clearfix"></div>
</div>
